import AllocationModal from '@/components/new/model/allocation_modal/AllocationModal.vue'
const myAllocationModal = {}
myAllocationModal.install = function (Vue) {
  const ModalConstructor = Vue.extend(AllocationModal)
  const instance = new ModalConstructor()
  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)
  Vue.prototype.$allocationConfirm = (type, width, height, title, success, cancel, close) => {
    instance.type = type
    instance.width = width
    instance.height = height
    instance.title = title
    instance.isShow = true
    if (typeof success !== 'undefined') {
      instance.success = success
    }
    if (typeof cancel !== 'undefined') {
      instance.cancel = cancel
    }
    if (typeof close !== 'undefined') {
      instance.close = close
    }
  }
}

export default myAllocationModal
